module.exports = __webpack_public_path__ + "img/customerLogo2.a3684eaa.png";